import { render, staticRenderFns } from "./VenueView.vue?vue&type=template&id=5b0060d4&scoped=true"
import script from "./VenueView.vue?vue&type=script&lang=ts"
export * from "./VenueView.vue?vue&type=script&lang=ts"
import style0 from "./VenueView.vue?vue&type=style&index=0&id=5b0060d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0060d4",
  null
  
)

export default component.exports